var r="production"===process.env.NODE_ENV,o="Invariant failed";function n(n,t){if(!n){if(r)throw new Error(o);var a="function"==typeof t?t():t,c=a?"".concat(o,": ").concat(a):o;throw new Error(c)}}export{n as default};
//# sourceMappingURL=tiny-invariant.js.map
